/**
 * Generated runtime TestId mirror for frontend/src/components/shared/ScriptSqlDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ScriptSqlDialogTestIds = {
  sqlDialog: "sql-dialog",
  sqlDialogBindingSelector: "sql-dialog-binding-selector",
  sqlDialogBlocklistCaption: "sql-dialog-blocklist-caption",
  sqlDialogCancelBtn: "sql-dialog-cancel-btn",
  sqlDialogErrorBanner: "sql-dialog-error-banner",
  sqlDialogExecuteCaption: "sql-dialog-execute-caption",
  sqlDialogExecuteParamsIgnored: "sql-dialog-execute-params-ignored",
  sqlDialogGroovyPreview: "sql-dialog-groovy-preview",
  sqlDialogInlineLiteralAdvisory: "sql-dialog-inline-literal-advisory",
  sqlDialogInsertBtn: "sql-dialog-insert-btn",
  sqlDialogLoadingSkeleton: "sql-dialog-loading-skeleton",
  sqlDialogParamsTextarea: "sql-dialog-params-textarea",
  sqlDialogResultTable: "sql-dialog-result-table",
  sqlDialogResultTypeSelector: "sql-dialog-result-type-selector",
  sqlDialogRollbackBadge: "sql-dialog-rollback-badge",
  sqlDialogSqlEditor: "sql-dialog-sql-editor",
  sqlDialogTrySqlBtn: "sql-dialog-try-sql-btn",
  sqlDialogVariableRefHint: "sql-dialog-variable-ref-hint"
} as const;
